import { hotComments, moreLinks } from "@/mocks/heiliaoHome";

export default function CommentsZone() {
  return (
    <section className="w-full bg-background-100/70">
      <div className="mx-auto max-w-[1280px] px-4 md:px-6 py-10 md:py-16">
        <div className="grid grid-cols-1 lg:grid-cols-5 gap-4 md:gap-6 items-start">
          {/* 左：热评墙 */}
          <div className="lg:col-span-3 rounded-lg border border-background-200/70 bg-background-50 p-4 md:p-6">
            <div className="flex flex-wrap items-center justify-between gap-3 mb-4">
              <div className="flex items-center gap-2">
                <span className="grid place-items-center h-8 w-8 rounded-md bg-accent-500 text-background-50">
                  <i className="ri-chat-heart-line text-lg"></i>
                </span>
                <div>
                  <h2 className="font-serif text-lg md:text-xl font-bold text-foreground-950">瓜友热评 · 说到点子上了</h2>
                  <p className="text-[11px] text-foreground-500">评论氛围很上头，讲理不撕</p>
                </div>
              </div>
              <span className="inline-flex items-center gap-1 rounded-full bg-accent-100 text-accent-900 px-3 py-1 text-xs font-medium">
                <i className="ri-fire-fill"></i> 本小时最热
              </span>
            </div>

            <div className="flex flex-col gap-3">
              {hotComments.map((c) => (
                <div key={c.author} className="rounded-lg border border-background-200/60 bg-background-100/50 p-3.5 md:p-4 hover:bg-background-100 transition-colors">
                  <div className="flex items-start gap-3">
                    <span className={`grid place-items-center h-10 w-10 shrink-0 rounded-full ${c.avatarClass} text-background-50 font-bold text-sm`}>
                      {c.initials}
                    </span>
                    <div className="flex-1 min-w-0">
                      <div className="flex flex-wrap items-center gap-2">
                        <span className="font-semibold text-sm text-foreground-950">{c.author}</span>
                        <span className={`rounded-md px-2 py-0.5 text-[10px] font-medium ${c.toneClass}`}>{c.tone}</span>
                        <span className="ml-auto text-[10px] text-foreground-400 whitespace-nowrap">{c.time}</span>
                      </div>
                      <p className="mt-2 text-sm leading-relaxed text-foreground-700">{c.text}</p>
                      <div className="mt-3 flex items-center gap-4 text-[11px] text-foreground-500">
                        <span className="flex items-center gap-1"><i className="ri-thumb-up-line text-primary-500"></i> {c.agree} 人同意</span>
                        <span className="flex items-center gap-1 cursor-pointer hover:text-primary-600 transition-colors"><i className="ri-chat-3-line"></i> 回复</span>
                        <span className="flex items-center gap-1 cursor-pointer hover:text-primary-600 transition-colors"><i className="ri-share-forward-line"></i> 转发</span>
                      </div>
                    </div>
                  </div>
                </div>
              ))}
            </div>

            {/* 伪评论输入（不真实提交） */}
            <div className="mt-4 flex items-center gap-3 rounded-md border border-background-300/60 bg-background-50 px-3 py-2.5">
              <span className="grid place-items-center h-8 w-8 rounded-full bg-secondary-500 text-background-50 text-xs font-bold">我</span>
              <span className="flex-1 text-sm text-foreground-400">说两句公道话，理性吃瓜不乱喷…</span>
              <span className="inline-flex items-center gap-1 whitespace-nowrap rounded-md bg-primary-500 text-background-50 px-3.5 py-1.5 text-xs font-semibold cursor-pointer hover:bg-primary-600 transition-colors">
                <i className="ri-send-plane-line"></i> 发表评论
              </span>
            </div>
          </div>

          {/* 右：往期归档 / 更多导航 */}
          <div className="lg:col-span-2 flex flex-col gap-4">
            <div className="rounded-lg border border-background-200/70 bg-background-50 p-4 md:p-6">
              <div className="flex items-center gap-2 mb-4">
                <span className="grid place-items-center h-8 w-8 rounded-md bg-secondary-500 text-background-50">
                  <i className="ri-archive-2-line text-lg"></i>
                </span>
                <div>
                  <h3 className="font-serif text-lg font-bold text-foreground-950">更多导航 &amp; 往期归档</h3>
                  <p className="text-[11px] text-foreground-500">收藏入口，随走随到</p>
                </div>
              </div>
              <div className="flex flex-col divide-y divide-background-200/60">
                {moreLinks.map((m) => (
                  <a
                    key={m.label}
                    href="#"
                    onClick={(e) => e.preventDefault()}
                    className="group flex items-start gap-3 py-3 hover:bg-background-100/60 rounded-md px-2 -mx-2 transition-colors cursor-pointer"
                  >
                    <span className="grid place-items-center h-9 w-9 shrink-0 rounded-lg bg-background-100 text-primary-600 group-hover:bg-primary-100 group-hover:text-primary-700 transition-colors">
                      <i className={`${m.icon} text-lg`}></i>
                    </span>
                    <span className="min-w-0">
                      <span className="block text-sm font-semibold text-foreground-900 group-hover:text-primary-700 transition-colors">{m.label}</span>
                      <span className="mt-0.5 block text-[11px] text-foreground-500 leading-snug">{m.desc}</span>
                    </span>
                  </a>
                ))}
              </div>
            </div>

            {/* 迷你 CTA */}
            <div className="relative overflow-hidden rounded-lg bg-accent-500 p-5">
              <i className="ri-megaphone-line absolute -right-3 -bottom-3 text-[90px] text-accent-400/50"></i>
              <p className="relative font-serif text-xl font-black text-background-50 leading-snug">找不到 1黑料网<br />最新入口？</p>
              <p className="relative mt-2 text-xs text-accent-100 leading-relaxed">把本页加入收藏，地址更新第一时间同步到导航栏。</p>
              <a
                href="#"
                onClick={(e) => e.preventDefault()}
                className="relative inline-flex items-center gap-2 mt-4 rounded-md bg-background-50 text-accent-700 px-4 py-2 text-sm font-semibold hover:bg-background-100 transition-colors cursor-pointer"
              >
                <i className="ri-bookmark-2-fill"></i> 收藏直达地址
              </a>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}